<template>
  <div class="cabinet-schedule">
    <div v-for="(item, index) in items" :key="`${item.month}-${index}`" class="cabinet-schedule__row">
      <span>{{ item.month }}</span>
      <cabinet-status :status="item.status" />
      <strong>{{ item.amount }}</strong>
    </div>
  </div>
</template>

<script>
import CabinetStatus from './CabinetStatus'

export default {
  name: 'CabinetSchedule',
  components: { CabinetStatus },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-schedule
  padding: 12px 14px
  border-radius: 10px
  background-color: #f8f8f8

.cabinet-schedule__row
  display: grid
  grid-template-columns: minmax(72px, 1fr) auto minmax(90px, 1fr)
  align-items: center
  gap: 8px
  padding: 10px 0
  border-bottom: 1px solid #e9e9e9
  color: #808080
  font-size: 13px

  &:last-child
    border-bottom: 0

  strong
    color: #3d3d3d
    font-weight: 500
    text-align: right
</style>
